import apiClient from "../../utils/request";
/**
 * 获取验证码
 */

export const getCode = async ({ phone, codeType }) =>
  await apiClient.post("/api/auth/send-code", { phone, codeType });

/**
 * 注册
 */

export const signUp = async ({ nickname, phone, code, password }) =>
  await apiClient.post("/api/auth/sign-up", {
    nickname,
    phone,
    code,
    password,
  });

/**
 * 登录
 */

export const signIn = async ({ phone, password, grantType, code }) =>
  await apiClient.post("/api/auth/sign-in", {
    phone,
    password,
    grantType,
    code,
  });

/**
 * 重置密码
 */

export const resetPassword = async ({ phone, code, password }) =>
  await apiClient.post("/api/auth/reset-password", {
    phone,
    code,
    password,
  });
